<template>
  <!--
    Bannière « drill-in » partagée (LOT G, G10) : affichée dans les pickers
    (scénarios / campagnes bulk / templates) quand la liste est filtrée sur une
    seule intégration. Extrait la version copiée-collée en styles inline dans les
    3 pickers pour une source unique. Émet `back` quand l'utilisateur revient à
    la liste complète.
  -->
  <div class="drilldown-banner">
    <button
      type="button"
      class="drilldown-banner__back"
      @click="$emit('back')"
    >
      <i class="fa-light fa-arrow-left" /> {{ t('integrations.collection.backToAll') }}
    </button>
    <span class="drilldown-banner__label">
      <img
        v-if="icon"
        :src="icon"
        :alt="name"
        class="drilldown-banner__icon"
      >
      {{ t('integrations.collection.byIntegration', { name }) }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'DrilldownBanner',

  props: {
    name: { type: String, required: true },
    icon: { type: String, default: null },
  },

  emits: ['back'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style scoped>
.drilldown-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #f6f4fd;
  border: 1px solid #e4ddf7;
  border-radius: 10px;
}

.drilldown-banner__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e4ddf7;
  color: #6346c4;
  font-weight: 600;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.drilldown-banner__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #1f2430;
  font-size: 14px;
}

.drilldown-banner__icon {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  object-fit: contain;
}
</style>
